module.exports = __webpack_public_path__ + "img/sweden-endocrine-nutritional-metabolic-diseases-male.ed4923b7.png";